import React, {Component} from 'react';
import { Link } from 'react-router-dom';

import styles from './styles.module.scss';

class View extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isMobileFilterOpen: false
        };
    }

    componentDidMount() {
        this.props.fetchTeams();
    }

    componentDidUpdate(prevProps) {
        // Re-fetch teams when organization changes
        if (this.props.organizationId && this.props.organizationId !== prevProps.organizationId) {
            this.props.fetchTeams();
        }
    }

    toggleMobileFilter = () => {
        this.setState(prev => ({ isMobileFilterOpen: !prev.isMobileFilterOpen }));
    }

    getSelectedFilterName() {
        for (var model of this.props.models) {
            if (model.selected) {
                return model.name;
            }
        }
        return 'All Athletes';
    }

    _renderModels() {
        var results = [];
        for (var model of this.props.models) {
            if (model.type === 'all') {
                if (model.selected) {
                    var style = styles.selectedTeamFilter;
                } else {
                    var style = styles.teamFilter;
                }
            } else if (model.type === 'team') {
                if (model.selected) {
                    var style = styles.selectedTeamFilter;
                } else {
                    var style = styles.teamFilter;
                }
            } else if (model.type === 'group') {
                if (model.selected) {
                    var style = styles.selectedGroupFilter;
                } else {
                    var style = styles.groupFilter;
                }
            } else {
                continue;
            }
            results.push(
                (<Link to={model.url} key={model.url} className={style}>{model.name}</Link>)
            );
        }
        return results;
    }

    _renderMobileFilter() {
        const { isMobileFilterOpen } = this.state;
        const selectedName = this.getSelectedFilterName();

        return (
            <div className={styles.mobileFilterWrapper}>
                <button
                    className={`${styles.mobileFilterToggle} ${isMobileFilterOpen ? styles.open : ''}`}
                    onClick={this.toggleMobileFilter}
                >
                    <span>{selectedName}</span>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M7 10l5 5 5-5z"/>
                    </svg>
                </button>
                <div className={`${styles.mobileFilterDropdown} ${isMobileFilterOpen ? styles.open : ''}`}>
                    {this.props.models.map(model => {
                        const isGroup = model.type === 'group';
                        const isSelected = model.selected;
                        return (
                            <Link
                                to={model.url}
                                key={model.url}
                                className={`${isSelected ? styles.selected : ''} ${isGroup ? styles.groupItem : ''}`}
                                onClick={() => this.setState({ isMobileFilterOpen: false })}
                            >
                                {model.name}
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className={styles.filterContainer}>
                    {this._renderModels()}
                </div>
                {this._renderMobileFilter()}
            </>
        );
    }

}

export default View;
